import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const ADMIN_FEATURE_FLAG_CODE: {
  FEATURE_FLAG_INVALID_FLAG_KEY: MvnCodeBE;
  FEATURE_FLAG_DUPLICATED: MvnCodeBE;
  FEATURE_FLAG_INVALID_RATIO: MvnCodeBE;
  FEATURE_FLAG_DESCRIPTION_REQUIRED: MvnCodeBE;
  FEATURE_FLAG_INVALID_GROUPS: MvnCodeBE;
  FEATURE_FLAG_INVALID_GROUP_KEY: MvnCodeBE;
  FEATURE_FLAG_DUPLICATED_GROUP_KEY: MvnCodeBE;
  FEATURE_FLAG_RATIO_SUM_INVALID: MvnCodeBE;
  FEATURE_FLAG_DEFAULT_GROUP_REQUIRED: MvnCodeBE;
  FEATURE_FLAG_INVALID_IS_DEFAULT: MvnCodeBE;
  FEATURE_FLAG_CACHE_SYNC_FAILED: MvnCodeBE;
} = {
  FEATURE_FLAG_INVALID_FLAG_KEY: {
    status: 400,
    ko: "Flag Key 형식이 올바르지 않습니다.",
    en: "Flag key format is invalid.",
  },
  FEATURE_FLAG_DUPLICATED: {
    status: 409,
    ko: "동일한 Service의 Flag Key가 이미 존재합니다.",
    en: "A feature flag with the same service and key already exists.",
  },
  FEATURE_FLAG_INVALID_RATIO: {
    status: 400,
    ko: "Ratio는 0~100 범위의 정수여야 합니다.",
    en: "Ratio must be an integer between 0 and 100.",
  },
  FEATURE_FLAG_DESCRIPTION_REQUIRED: {
    status: 400,
    ko: "Description은 필수 입력값입니다.",
    en: "Description is required.",
  },
  FEATURE_FLAG_INVALID_GROUPS: {
    status: 400,
    ko: "그룹은 최소 1개 이상이어야 합니다.",
    en: "At least one group is required.",
  },
  FEATURE_FLAG_INVALID_GROUP_KEY: {
    status: 400,
    ko: "Group Key 형식이 올바르지 않습니다.",
    en: "Group key format is invalid.",
  },
  FEATURE_FLAG_DUPLICATED_GROUP_KEY: {
    status: 400,
    ko: "Flag 내에서 Group Key는 중복될 수 없습니다.",
    en: "Group key must be unique within a flag.",
  },
  FEATURE_FLAG_RATIO_SUM_INVALID: {
    status: 400,
    ko: "그룹 비율의 합이 100이 되어야 합니다.",
    en: "Sum of group ratios must equal 100.",
  },
  FEATURE_FLAG_DEFAULT_GROUP_REQUIRED: {
    status: 400,
    ko: "기본 그룹은 정확히 1개 지정되어야 합니다.",
    en: "Exactly one group must be marked as default.",
  },
  FEATURE_FLAG_INVALID_IS_DEFAULT: {
    status: 400,
    ko: "isDefault 는 boolean 이어야 합니다.",
    en: "isDefault must be a boolean.",
  },
  FEATURE_FLAG_CACHE_SYNC_FAILED: {
    status: 503,
    ko: "Redis 캐시 반영에 실패하여 변경 사항이 롤백되었습니다. 잠시 후 다시 시도해주세요.",
    en: "Failed to sync Redis cache. The changes have been rolled back. Please retry later.",
  },
};

MvnCodeInitiate(ADMIN_FEATURE_FLAG_CODE);
